import createDiagonalStripes from './createDiagonalStripes';
import colors from './colors';

const gradients = {
  TRANSPARENT_TO_WHITE: 'linear-gradient(90deg, #FFFFFF00, #FFFFFF)',
  GRAY_DIAGONAL_STRIPES: createDiagonalStripes({
    stripeColor: colors.DIVIDER,
    background: colors.GREY_50,
  }),
  BLUE_50_DIAGONAL_STRIPES: createDiagonalStripes({
    stripeColor: colors.GREY_200,
    background: colors.BLUE_50,
  }),
  CYAN_50_DIAGONAL_STRIPES: createDiagonalStripes({
    stripeColor: colors.GREY_200,
    background: colors.CYAN_50,
  }),
};

export default gradients;
